(function() {
  /* start-dbtfy-addons */

  /* start-dbtfy-addtocart-animation */
  function themeAddtocartAnimation() {}
  /* end-dbtfy-addtocart-animation */

  /* start-dbtfy-age-check */
  function themeAgeCheck() {}

  function themeAgeCheckDestroy() {}
  /* end-dbtfy-age-check */

  /* start-dbtfy-agree-to-terms */
  function themeAgreeToTerms() {}

  function themeAgreeToTermsDestroy() {}
  /* end-dbtfy-agree-to-terms */

  /* start-dbtfy-automatic-geolocation */
  function themeAutomaticGeolocation() {}
  /* end-dbtfy-automatic-geolocation */

  /* start-dbtfy-back-in-stock */
  function themeBackInStock() {}

  function themeBackInStockDestroy() {}
  /* end-dbtfy-back-in-stock */

  /* start-dbtfy-cart-countdown */
  function themeCartCountdown() {}

  function themeCartCountdownDestroy() {}
  /* end-dbtfy-cart-countdown */

  /* start-dbtfy-cart-discount */
  function themeCartDiscount() {}

  function themeCartDiscountDestroy() {}
  /* end-dbtfy-cart-discount */

  /* start-dbtfy-cart-favicon */
  function themeCartFavicon() {}
  /* end-dbtfy-cart-favicon */

  /* start-dbtfy-cart-goal */
  function themeCartGoal() {}

  function themeCartGoalDestroy() {}
  /* end-dbtfy-cart-goal */

  /* start-dbtfy-cart-savings */
  function themeCartSavings() {}

  function themeCartSavingsDestroy() {}
  /* end-dbtfy-cart-savings */

  /* start-dbtfy-cart-upsell */
  function themeCartUpsell() {}

  function themeCartUpsellDestroy() {}
  /* end-dbtfy-cart-upsell */

  /* start-dbtfy-collection-addtocart */
  function themeCollectionAddtocart() {}

  function themeCollectionAddtocartDestroy() {}
  /* end-dbtfy-collection-addtocart */

  /* start-dbtfy-collection-filters */
  function themeCollectionFilters() {}

  function themeCollectionFiltersDestroy() {}
  /* end-dbtfy-collection-filters */

  /* start-dbtfy-color-swatches */
  function themeColorSwatches() {}

  function themeColorSwatchesDestroy() {}
  /* end-dbtfy-color-swatches */

  /* start-dbtfy-cookie-box */
  function themeCookieBox() {}

  function themeCookieBoxDestroy() {}
  /* end-dbtfy-cookie-box */

  /* start-dbtfy-custom-currencies */
  function themeCustomCurrencies() {}

  function themeCustomCurrenciesDestroy() {}
  /* end-dbtfy-custom-currencies */

  /* start-dbtfy-delivery-time */
  function themeDeliveryTimeDestroy() {}
  /* end-dbtfy-delivery-time */

  /* start-dbtfy-discount-saved */
  function themeDiscountSaved() {}

  function themeDiscountSavedDestroy() {}
  /* end-dbtfy-discount-saved */

  /* start-dbtfy-facebook-messenger */
  function themeFacebookMessengerDestroy() {}
  /* end-dbtfy-facebook-messenger */

  /* start-dbtfy-faq-page */
  function themeFaqPage() {}

  function themeFaqPageDestroy() {}
  /* end-dbtfy-faq-page */

  /* start-dbtfy-inactive-tab-message */
  function themeInactiveTabMessage() {function InactiveTabMessage() {
      const pageTitle = document.title;
      const firstMessage = theme.settings.dbtfyInactiveTabFirstMessage;
      const secondMessage = theme.settings.dbtfyInactiveTabSecondMessage ? theme.settings.dbtfyInactiveTabSecondMessage : pageTitle;
      const flashingEffect = !!theme.settings.dbtfyInactiveTabSecondMessage;
      const delay = theme.settings.dbtfyInactiveTabDelay * 1000;
      let isOldTitle = false;
      let timer = "";

      if (!firstMessage) {
        return;
      }

      document.addEventListener("visibilitychange", function(e) {
        const isPageActive = !document.hidden;

        if (!isPageActive) {
          if (flashingEffect) {
            changeTitle();
          } else {
            document.title = firstMessage;
          }
        } else {
          clearInterval(timer);
          document.title = pageTitle;
        }
      });

      function changeTitle() {
        timer = setInterval(function () {
          document.title = isOldTitle ? secondMessage : firstMessage;
          isOldTitle = !isOldTitle;
        }, delay);
      }
    }

    InactiveTabMessage();}
  /* end-dbtfy-inactive-tab-message */

  /* start-dbtfy-infinite-scroll */
  function themeInfiniteScroll() {}

  function themeInfiniteScrollDestroy() {}
  /* end-dbtfy-infinite-scroll */

  /* start-dbtfy-instagram-feed */
  function themeInstagramFeed() {}

  function themeInstagramFeedDestroy() {}
  /* end-dbtfy-instagram-feed */

  /* start-dbtfy-inventory-quantity */
  function themeInventoryQuantity() {}

  function themeInventoryQuantityDestroy() {}
  /* end-dbtfy-inventory-quantity */

  /* start-dbtfy-linked-options */
  function themeLinkedOptions() {}
  /* end-dbtfy-linked-options */

  /* start-dbtfy-live-view */
  function themeLiveView() {}

  function themeLiveViewDestroy() {}
  /* end-dbtfy-live-view */

  /* start-dbtfy-mega-menu */
  function themeMegaMenu() {}

  function themeMegaMenuDestroy() {}
  /* end-dbtfy-mega-menu */

  /* start-dbtfy-menu-bar */
  function themeMenuBarDestroy() {}
  /* end-dbtfy-menu-bar */

  /* start-dbtfy-newsletter-popup */
  function themeNewsletterPopup() {}

  function themeNewsletterPopupDestroy() {}
  /* end-dbtfy-newsletter-popup */

  /* start-dbtfy-order-feedback */
  function themeOrderFeedback() {}

  function themeOrderFeedbackDestroy() {}
  /* end-dbtfy-order-feedback */

  /* start-dbtfy-order-tracking */
  function themeOrderTracking() {}

  function themeOrderTrackingDestroy() {}
  /* end-dbtfy-order-tracking */

  /* start-dbtfy-page-transition */
  function themePageTransition() {}

  function themePageTransitionDestroy() {}
  /* end-dbtfy-page-transition */

  /* start-dbtfy-page-speed-booster */
  function themePageSpeedBooster() {}
  /* end-dbtfy-page-speed-booster */

  /* start-dbtfy-pricing-table */
  function themePricingTableDestroy() {}
  /* end-dbtfy-pricing-table */

  /* start-dbtfy-product-bullet-points */
  function themeProductBulletPoints() {}

  function themeProductBulletPointsDestroy() {}
  /* end-dbtfy-product-bullet-points */

  /* start-dbtfy-product-image-crop */
  function themeProductImageCropDestroy() {}
  /* end-dbtfy-product-image-crop */

  /* start-dbtfy-product-tabs */
  function themeProductTabsDestroy() {}
  /* end-dbtfy-product-tabs */

  /* start-dbtfy-quantity-breaks */
  function themeQuantityBreaks() {function QuantityBreaks() {
      const dbtfy = document.querySelector(".dbtfy-quantity_breaks");

      if (!dbtfy) {
        return;
      }

      const singleBreakText = dbtfy.dataset.singleBreakText;
      const moreDiscountBeforeQuantityText = dbtfy.dataset.moreDiscountBeforeQuantityText;
      const moreDiscountAfterQuantityText = dbtfy.dataset.moreDiscountAfterQuantityText;
      const moreDiscountAfterPercentageText = dbtfy.dataset.moreDiscountAfterPercentageText;
      const highestDiscountText = dbtfy.dataset.highestDiscountText;
      const quantityBreaks = dbtfy.querySelectorAll(".qb-quantity");
      const quantityWrappers = document.querySelectorAll(".product-single__form .product-single__quantity");
      const atcButtons = document.querySelectorAll(".product-single__form .product-single__add-to-cart");
      const quantityLabel = document.querySelector(".product-single__quantity label");
      const productSelectors = document.querySelectorAll(".product-form__input, .single-option-radio, .input-color_swatches");
      const formsWithDefaultVariants = document.querySelectorAll(".product-single__form--no-variants");
      const productsJSON = {};
      const quantityLabelText = theme.strings.quantityLabel;
      const moneyFormat = theme.strings.moneyFormat;

      if (!quantityBreaks.length) {
        return;
      }

      if (quantityLabel) {
        quantityLabel && quantityLabel.removeAttribute("hidden");
      }

      if (quantityWrappers.length) {
        quantityWrappers.forEach((quantityWrapper) => {
          const clonedDbtfy = dbtfy.cloneNode(true);
          const quantities = clonedDbtfy.querySelectorAll(".qb-quantity");
          const container = quantityWrapper.querySelector(".qty-container");
          const productSection = quantityWrapper.closest("[data-section-type='product-template']");
          const productSectionId = productSection.dataset.sectionId;
          const form = productSection.querySelector(".product-single__form");
          const productJSONScript = document.getElementById(`ProductJson-${productSectionId}`);

          if (productJSONScript) {
            changeQuantityBreaksId(quantities, productSectionId);
            saveQuantityBreaksDiscounts(quantities);

            theme.removeAllChildNodes(container);
            clonedDbtfy.removeAttribute("hidden");
            container.insertAdjacentElement("beforeend", clonedDbtfy);
            productsJSON[productSectionId] = JSON.parse(productJSONScript.innerHTML);
          }

          if (form) {
            form.addEventListener("submit", () => {
              applyQuantityBreakDiscount(form);
            });
          }
        });
      } else {
        atcButtons.forEach((atcButton) => {
          const clonedDbtfy = dbtfy.cloneNode(true);
          const quantities = clonedDbtfy.querySelectorAll(".qb-quantity");
          const container = document.createElement("div");
          const productSection = atcButton.closest("[data-section-type='product-template']");
          const productSectionId = productSection.dataset.sectionId;
          const productJSONScript = document.getElementById(`ProductJson-${productSectionId}`);

          changeQuantityBreaksId(quantities, productSectionId);
          saveQuantityBreaksDiscounts(quantities);

          container.classList.add("qty-container");
          container.insertAdjacentHTML(`
              <label for="Quantity" class="quantity-break-label">${quantityLabelText}</label>
              ${clonedDbtfy.innerHTML}
            `);

          if (productJSONScript) {
            productsJSON[productSectionId] = JSON.parse(productJSONScript.innerHTML);
          }

          atcButton.insertAdjacentElement("beforebegin", container);
        });
      }

      productSelectors.length && productSelectors.forEach((productSelector) => {
        productSelector.addEventListener("change", function(e) {
          updateQuantityBreaks(e);
        });

        updateQuantityBreaks({
          target: productSelector
        });
      });

      formsWithDefaultVariants.forEach((form) => {
        updateQuantityBreaks({
          target: form
        });
      });

      function saveQuantityBreaksDiscounts(quantities) {
        const discounts = [];

        quantities.forEach((quantity) => {
          const input = quantity.querySelector("input");
          const breakCount = +input.value;
          const discountName = input.dataset.discountCode;
          const discountType = input.dataset.discountType;
          const discountAmount = +input.dataset.discountAmount;

          if (discountName && discountType && discountAmount) {
            discounts.push({
              breakCount: breakCount,
              name: discountName,
              type: discountType,
              amount: discountAmount
            });
          }
        });

        if (discounts.length) {
          // Sort from min to max by breakCount field
          discounts.sort((a, b) => a.breakCount - b.breakCount);

          sessionStorage.setItem("quantity-breaks-discounts", JSON.stringify(discounts));
        }
      }

      function changeQuantityBreaksId(quantities, productSectionId) {
        quantities.forEach((quantity) => {
          const label = quantity.querySelector("label");
          const input = quantity.querySelector("input");

          label.setAttribute("for", `${input.id}-${productSectionId}`);
          input.setAttribute("id", `${input.id}-${productSectionId}`);
        });
      }

      function updateQuantityBreaks(e) {
        const productSection = e.target.closest("[data-section-type='product-template']");

        if (!productSection) {
          return;
        }

        const variantSelect = productSection.querySelector("[id^='MainProductSelect']");
        const currentVariant = variantSelect.querySelector("option:checked");
        const variantId = currentVariant ? +currentVariant.value : null;
        const productSectionId = productSection.dataset.sectionId;
        const quantityBreaks = productSection.querySelectorAll(".qb-quantity");
        const productJSON = productsJSON[productSectionId];

        if (!productJSON) {
          return;
        }

        const variant = productJSON.variants.find((variant) => {
          return variant.id === variantId;
        });

        if (!variant) {
          return;
        }

        quantityBreaks.forEach((quantityBreak) => {
          const label = quantityBreak.querySelector("label");
          const input = quantityBreak.querySelector("input");
          const breakCount = +input.value;
          const discountType = input.dataset.discountType;
          const discountAmount = +input.dataset.discountAmount;
          let price = variant.price;
          let comparePrice = variant.compare_at_price;
          let labelText = singleBreakText;
          let savedAmount = "";

          // Replace _COUNT_ variable
          labelText = labelText.replace("_COUNT_", breakCount);

          // Replace _PRICE_ variable
          if (breakCount > 1) {
            comparePrice = price * breakCount;

            switch (discountType) {
              case "$":
                price = comparePrice - (discountAmount * 100);
                savedAmount = `<span class="money">${theme.Currency.formatMoney(discountAmount * 100, moneyFormat)}</span>`;

                break;

              case "%":
                price = comparePrice - (comparePrice / 100 * discountAmount);
                savedAmount = `${discountAmount}%`;

                break;
            }
          }

          if (price < 0 || comparePrice < 0) {
            quantityBreak.setAttribute("data-invalid-value", "true");
          } else {
            quantityBreak.removeAttribute("data-invalid-value");
          }

          if (comparePrice) {
            labelText = labelText.replace("_PRICE_", `
                <span class="qb-price text-money">
                  <span class="qb-discounted-price on-sale text-sale">
                    <span class="money">
                      ${theme.Currency.formatMoney(price, moneyFormat)}
                    </span>
                  </span>

                  <span class="qb-original-price text-strike text-muted">
                    <span class="money">
                      ${theme.Currency.formatMoney(comparePrice, moneyFormat)}
                    </span>
                  </span>
                </span>
              `);
          } else {
            labelText = labelText.replace("_PRICE_", `
                <span class="qb-price text-money">
                  <span class="money">
                    ${theme.Currency.formatMoney(price, moneyFormat)}
                  <span>
                </span>
              `);
          }

          // Replace _SAVED_AMOUNT_ variable
          if (breakCount > 1) {
            const savedAmountText = theme.strings.saveLabel.replace("\{\{ saved_amount \}\}", savedAmount);

            labelText = labelText.replace("_SAVED_AMOUNT_", `
                <span class="badge qb-saved-amount">
                  ${savedAmountText}
                </span>
              `);
          } else {
            labelText = labelText.replace("_SAVED_AMOUNT_", "");
          }

          label.innerHTML = labelText;
        });

        hideUnnecessaryBreaks();

        // Convert the quantity breaks amount on custom currency switcher
        var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
          shopCurrency = theme.strings.shopCurrency;

        if (currencySelector.length) {
          Currency.convertAll(shopCurrency, Currency.currentCurrency, ".qb-price .money, .qb-saved-amount .money");
        }
      }

      function hideUnnecessaryBreaks() {
        if (!theme.cart) {
          document.addEventListener("dbtfy:cartLoaded", init);
        } else {
          init();
        }

        function init() {
          const quantityBreaksWrappers = document.querySelectorAll(".dbtfy-quantity_breaks");

          quantityBreaksWrappers.forEach((quantityBreak) => {
            const quantities = quantityBreak.querySelectorAll(".qb-quantity");
            const productSection = quantityBreak.closest("[data-section-type='product-template']");

            if (!productSection) {
              return;
            }

            const variantSelect = productSection.querySelector("[id^='MainProductSelect']");
            const currentVariant = variantSelect.querySelector("option:checked");
            const variantId = +currentVariant.value;
            const productSectionId = productSection.dataset.sectionId;
            const productJSON = productsJSON[productSectionId];

            if (!productJSON) {
              return;
            }

            const variantJSON = productJSON.variants.find((variant) => {
              return variant.id === variantId;
            });

            if (!variantJSON) {
              return;
            }

            const cart = theme.cart;
            const variantInventoryQuantity = +currentVariant.dataset.inventoryQuantity || 0;
            const variantInventoryPolicy = currentVariant.dataset.inventoryPolicy;
            const currentVariantInCartQuantity = cart.items.reduce((acc, item) => {
              if (item.id === variantId) {
                return acc + item.quantity;
              }

              return acc;
            }, 0);

            const ableToBuyCount = variantInventoryQuantity - currentVariantInCartQuantity;

            if (variantJSON.available) {
              // If track quantity is enabled
              if (variantJSON.inventory_management === "shopify" && variantInventoryPolicy !== "continue") {
                showQuantityBreaks(ableToBuyCount, quantities);
              } else {
                showQuantityBreaks(30, quantities);
              }
            } else {
              showQuantityBreaks(0, quantities);
            }
          });
        }

        function showQuantityBreaks(availableAmount, quantityBreaks) {
          quantityBreaks.forEach((quantityBreak) => {
            const input = quantityBreak.querySelector("input");
            const breakCount = +input.value;

            if (breakCount === 1) {
              input.checked = true;
            }

            if (breakCount > availableAmount || quantityBreak.hasAttribute("data-invalid-value")) {
              quantityBreak.setAttribute("hidden", "hidden");
            } else {
              quantityBreak.removeAttribute("hidden");
            }
          });
        }
      }

      function applyQuantityBreakDiscount(form) {
        const activeQuantityBreak = form.querySelector(".qb-quantity input:checked");
        const breakCount = +activeQuantityBreak.value;
        const discountCode = activeQuantityBreak.dataset.discountCode;
        const discountType = activeQuantityBreak.dataset.discountType;
        const discountAmount = +activeQuantityBreak.dataset.discountAmount;

        if (discountCode && discountType && discountAmount) {
          theme.discountCode.addDiscount(discountCode, discountType, discountAmount, {
            breakCount: breakCount,
            role: "quantity-breaks"
          });
        }
      }

      function breaksOnCartUpdate(cart) {
        const cartTotal = cart.total_price;
        const breaksDiscounts = JSON.parse(sessionStorage.getItem("quantity-breaks-discounts"));

        if (!breaksDiscounts) {
          return;
        }

        const suitableBreaksDiscounts = [];
        const cartItemsCount = cart.item_count;

        breaksDiscounts.forEach((discount) => {
          const breakCount = discount.breakCount;
          const discountName = discount.name;
          const discountType = discount.type;
          const discountAmount = discount.amount;

          if (cartItemsCount >= breakCount) {
            suitableBreaksDiscounts.push({
              name: discountName,
              type: discountType,
              amount: discountAmount
            });
          }
        });

        // Remove all existed Quantity breaks discounts
        const discounts = theme.discountCode.getStoredDiscounts();

        breaksDiscounts.forEach((discount) => {
          const storedDiscount = discounts.find((storedDiscount) => {
            return storedDiscount.name === discount.name;
          });

          if (storedDiscount && storedDiscount.role === "quantity-breaks") {
            theme.discountCode.removeDiscount(discount.name);
          }
        });

        // Get max valuable Quantity breaks discount
        let discountWithMaxValue = null;
        let maxValue = 0;

        suitableBreaksDiscounts.forEach((suitableDiscount) => {
          const savedMoney = getSavedMoney(suitableDiscount, cart);

          if (!discountWithMaxValue || savedMoney >= maxValue) {
            if (savedMoney <= cartTotal) {
              discountWithMaxValue = suitableDiscount;
              maxValue = savedMoney;
            }
          }
        });

        if (discountWithMaxValue) {
          const isDiscountWithMaxValueInDiscounts = theme.discountCode.hasDiscount(discountWithMaxValue.name);

          // Quantity breaks discount not in discounts
          if (!isDiscountWithMaxValueInDiscounts && Object.keys(discountWithMaxValue).length > 0) {
            const discountName = discountWithMaxValue.name;
            const discountType = discountWithMaxValue.type;
            const discountAmount = discountWithMaxValue.amount;

            theme.discountCode.addDiscount(discountName, discountType, discountAmount, {
              role: "quantity-breaks"
            });
          }
        }

        hideUnnecessaryBreaks();
        showQuantityBreaksMessageInCart(cart);

        theme.discountCode.init();
      }

      function showQuantityBreaksMessageInCart(cart) {
        const ajaxCartSubtotal = document.querySelector("#CartDrawer .cart__total-price-info");
        const cartPageCartSubtotal = document.querySelector("#cartForm .cart__total-price-info");
        const discounts = theme.discountCode.getStoredDiscounts();
        const mostValuableDiscount = theme.discountCode.getMostValuableDiscount(discounts, cart);
        const mostValuableDiscountSavedAmount = getSavedMoney(mostValuableDiscount, cart);
        const quantityBreaksDiscounts = JSON.parse(sessionStorage.getItem("quantity-breaks-discounts"));
        const cartItemsCount = cart.item_count;
        const cartTotal = cart.total_price;

        let message = `<div class="dbtfy dbtfy-quantity_breaks"><div class="card card-body-xs text-center qb-alert">`;

        const nextMostValuableQuantityBreakDiscount = quantityBreaksDiscounts.find((discount) => {
          const discountSavedAmount = getSavedMoney(discount, cart);
          const discountBreakCount = discount.breakCount;

          return discountSavedAmount > mostValuableDiscountSavedAmount && discountBreakCount > cartItemsCount && discountSavedAmount <= cartTotal;
        });

        if (nextMostValuableQuantityBreakDiscount) {
          const nextBreakDiscountCount = nextMostValuableQuantityBreakDiscount.breakCount - cartItemsCount;
          let nextBreakDiscountAmount = `${nextMostValuableQuantityBreakDiscount.amount}%`;

          if (nextMostValuableQuantityBreakDiscount.type === "$") {
            nextBreakDiscountAmount = `<span class="money">${theme.Currency.formatMoney(nextMostValuableQuantityBreakDiscount.amount * 100, moneyFormat)}</span>`;
          }

          if (moreDiscountBeforeQuantityText || moreDiscountAfterQuantityText || moreDiscountAfterPercentageText) {
            message += `<div class="qb-text">${moreDiscountBeforeQuantityText} <strong class="text-secondary">${nextBreakDiscountCount}</strong> ${moreDiscountAfterQuantityText} <strong class="text-secondary">${nextBreakDiscountAmount}</strong> ${moreDiscountAfterPercentageText}</div>`;
          }
        } else if (highestDiscountText && mostValuableDiscountSavedAmount > 0) {
          message += `<div class="qb-highest-discount-text">${highestDiscountText}</div>`;
        }

        message += "</div></div>";

        // Insert into cart drawer
        const existedDrawerAlert = document.querySelector(".qb-alert-drawer-wrapper");

        if (existedDrawerAlert) {
          existedDrawerAlert.remove();
        }

        if (ajaxCartSubtotal) {
          ajaxCartSubtotal.insertAdjacentHTML("afterend", message);

          const messageInDrawer = document.querySelector("#CartDrawer .dbtfy-quantity_breaks");

          if (messageInDrawer) {
            messageInDrawer.classList.add("qb-alert-drawer-wrapper", "spacer-top");
          }
        }

        // Insert on cart page
        const existedCartPageAlert = document.querySelector(".qb-alert-wrapper");

        if (existedCartPageAlert) {
          existedCartPageAlert.remove();
        }

        if (cartPageCartSubtotal) {
          cartPageCartSubtotal.insertAdjacentHTML("afterend", message);

          const messageInCartPage = document.querySelector("#cartForm .dbtfy-quantity_breaks");

          if (messageInCartPage) {
            messageInCartPage.classList.add("qb-alert-wrapper", "spacer-top-sm", "spacer-bottom");
          }
        }

        // Convert the quantity breaks amount on custom currency switcher
        var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
          shopCurrency = theme.strings.shopCurrency;

        if (currencySelector.length) {
          Currency.convertAll(shopCurrency, Currency.currentCurrency, ".qb-alert .money");
        }
      }

      function getSavedMoney(discount, cart) {
        let savedMoney = 0;

        if (discount) {
          switch (discount.type) {
            case "$":
              savedMoney = discount.amount * 100;

              break;

            case "%":
              savedMoney = cart.items_subtotal_price * (discount.amount / 100);

              break;
          }
        }

        return savedMoney;
      }

      document.addEventListener("dbtfy:upsellPopupLoaded", () => {
        if (theme.isCartLoaded) {
          breaksOnCartUpdate(theme.cart);
        } else {
          document.addEventListener("dbtfy:cartLoaded", () => {
            breaksOnCartUpdate(theme.cart);
          });
        }
      });

      $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
        breaksOnCartUpdate(cart);
      });

      // If cart page
      if (document.body.classList.contains("template-cart")) {
        if (theme.isCartLoaded) {
          breaksOnCartUpdate(theme.cart);
        } else {
          document.addEventListener("dbtfy:cartLoaded", () => {
            breaksOnCartUpdate(theme.cart);
          });
        }
      }
    }

    QuantityBreaks();}

  function themeQuantityBreaksDestroy() {document.body.classList.add("dbtfy-quantity_breaks-destroy");

    destroyQuantityBreaks();

    function destroyQuantityBreaks() {
      const quantityBreaks = document.querySelectorAll(".qb-wrapper");
      const productQuantities = document.querySelectorAll(".product-single__quantity");

      quantityBreaks.length && quantityBreaks.forEach((quantityBreak) => {
        quantityBreak.remove();
      });

      productQuantities.length && productQuantities.forEach((productQuantity) => {
        const isQuantityEnabled = productQuantity.hasAttribute("data-quantity-enabled");
        const isQuantityInventoryEnabled = productQuantity.hasAttribute("data-inventory-quantity-enabled");

        if (!isQuantityEnabled && !isQuantityInventoryEnabled) {
          productQuantity.remove();
        }
      });
    }}
  /* end-dbtfy-quantity-breaks */

  /* start-dbtfy-quick-view */
  function themeQuickView() {}

  function themeQuickViewDestroy() {}
  /* end-dbtfy-quick-view */

  /* start-dbtfy-recently-viewed */
  function themeRecentlyViewed() {}

  function themeRecentlyViewedDestroy() {}
  /* end-dbtfy-recently-viewed */

  /* start-dbtfy-sales-countdown */
  function themeSalesCountdown() {}

  function themeSalesCountdownDestroy() {}
  /* end-dbtfy-sales-countdown */

  /* start-dbtfy-sales-pop */
  function themeSalesPop() {}

  function themeSalesPopDestroy() {}
  /* end-dbtfy-sales-pop */

  /* start-dbtfy-shop-protect */
  function themeShopProtect() {}
  /* end-dbtfy-shop-protect */

  /* start-dbtfy-size-chart */
  function themeSizeChart() {}

  function themeSizeChartDestroy() {}
  /* end--dbtfy-size-chart */

  /* start-dbtfy-smart-search */
  function themeSmartSearch() {}

  function themeSmartSearchDestroy() {}
  /* end-dbtfy-smart-search */

  /* start-dbtfy-social-discount */
  function themeSocialDiscount() {}

  function themeSocialDiscountDestroy() {}
  /* end-dbtfy-social-discount */

  /* start-dbtfy-sticky-addtocart */
  function themeStickyAddtocart() {async function StickyAddtocart() {
      let stickyATC = document.querySelector(".dbtfy-sticky_addtocart");

      if (!stickyATC) {
        return;
      }

      const listVariantSelects = document.querySelectorAll(".single-option-selector__radio");
      const masterSelect = document.querySelector("[id^='MainProductSelect']");
      const productTemplateMetaContainer = document.querySelector("#ProductMeta-product-template");
      let cart = await ShopifyAPI.getCart();
      let dataPosition = stickyATC.dataset.position;
      let stickyImages = stickyATC.querySelectorAll(".image-sticky_addtocart");
      let addtocartButton = document.querySelector(".product-single__add-to-cart .btn--add-to-cart");
      let stickyAddtocart = stickyATC.querySelector("#stickyAddToCart");
      let stickyATCButton = stickyATC.querySelector(".btn--sticky_addtocart");
      let stickyATCButtonText = stickyATCButton.querySelector(".btn-text-sticky_addtocart");
      let targetScroll = addtocartButton.offsetTop + addtocartButton.offsetHeight;
      let moneyFormat = theme.strings.moneyFormat;
      let animTime = theme.variables.animationDuration;
      let scrollClass = dataPosition === "top" ? null: "scroll-sticky_addtocart";
      let visibleClass = "sa-visible";
      let hasReachedScroll = false;
      let qtBox = document.querySelector(".quantity-sticky_addtocart");
      let variantStickyProduct = stickyATC.querySelector(".select-sticky_addtocart");
      let qtyField = qtBox.querySelector("input");

      // Scroll event
      window.addEventListener("scroll", () => {
        if (window.pageYOffset > targetScroll) {
          stickyAddtocart.classList.add(visibleClass);
          scrollClass && document.body.classList.add(scrollClass);
          hasReachedScroll = true;
        } else {
          if (hasReachedScroll) {
            hasReachedScroll = false;

            theme.closeTransition({
              elementToTransition: stickyAddtocart,
              animationSpeed: animTime
            }, function () {
              stickyAddtocart.classList.remove(visibleClass);
              scrollClass && document.body.classList.remove(scrollClass);
            });
          }
        }
      });

      function calculateDiscountPrice(totalPrice, totalComparePrice, variant) {
        let discount = null;

        if (variant === "percentage") {
          let discountValue = Math.floor(((totalComparePrice - totalPrice) * 100) / totalComparePrice);
          discount = `${discountValue}%`;
        } else {
          let discountValue = totalComparePrice - totalPrice;
          discount = theme.Currency.formatMoney(discountValue, moneyFormat);
        }

        return discount;
      }

      function checkPrice() {
        let priceBox = stickyATC.querySelector(".total-sticky-price");
        let comparePriceBox = stickyATC.querySelector(".total-sticky-compare-price");
        let stickyDiscountBox = stickyATC.querySelector(".discount-sticky-price");
        let stickyDiscountBoxText = stickyATC.querySelector(".discount-sticky-price-text");
        let selectedVariant = variantStickyProduct.options[variantStickyProduct.selectedIndex];

        if (!selectedVariant) {
          return;
        }

        let variantPrice = +selectedVariant.dataset.price;
        let variantCompareAtPrice = +selectedVariant.dataset.compareAtPrice;
        let discountSaved = Boolean(stickyATC.querySelector(".dbtfy-sticky-price-box").dataset.discountSaved);

        priceBox.innerHTML = `<span class="money">${theme.Currency.formatMoney(variantPrice, moneyFormat)}</span>`;

        if (variantPrice < variantCompareAtPrice) {
          comparePriceBox.innerHTML = `<span class="money">${theme.Currency.formatMoney(variantCompareAtPrice, moneyFormat)}</span>`;
          comparePriceBox.style.display = "inline-block";
          priceBox.classList.add("text-sale");

          if (stickyDiscountBox && discountSaved) {
            let discountVariant = stickyDiscountBox.dataset.discountVariant;
            let discountValue = calculateDiscountPrice(variantPrice, variantCompareAtPrice, discountVariant);

            const valueStr = (discountVariant === "percentage") ? discountValue : `<span class="money">${discountValue}</span>`;

            stickyDiscountBoxText.innerHTML = theme.strings.saveFormat.replace(/\{\{ saved_amount \}\}/, valueStr);
            stickyDiscountBox.style.display = "inline-block";
          }
        } else {
          comparePriceBox.style.display = "none";
          priceBox.classList.remove("text-sale");

          if (stickyDiscountBox) {
            stickyDiscountBox.style.display = "none";
          }
        }

        // Convert the product price on select change based on selected currency
        var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
          shopCurrency = theme.strings.shopCurrency;

        if (currencySelector.length && shopCurrency && Currency.currentCurrency) {
          Currency.convertAll(shopCurrency, Currency.currentCurrency);
        }
      }

      function setMaxQuantity() {
        if (variantStickyProduct) {
          const currentVariant = variantStickyProduct.selectedOptions[0];
          const currentVariantInventory = currentVariant.hasAttribute("data-remain-qty") ? +currentVariant.dataset.remainQty : +currentVariant.dataset.productQty;

          if (currentVariantInventory > 0) {
            qtyField.setAttribute("max", currentVariantInventory);
          } else {
            qtyField.removeAttribute("max");
          }
        }
      }

      function checkQuantity() {
        const currentVariant = variantStickyProduct.selectedOptions[0];

        if (!currentVariant) {
          return;
        }

        const variantQty = currentVariant.hasAttribute("data-remain-qty") ? +currentVariant.dataset.remainQty : +currentVariant.dataset.productQty;
        const currentValue = +qtyField.value;
        const qtPlusButton = qtBox.querySelector(".qty-plus");

        if (variantQty > 0) {
          if (currentValue >= variantQty) {
            qtPlusButton.setAttribute("disabled", "disabled");
            qtyField.value = variantQty;
          } else {
            qtPlusButton.removeAttribute("disabled");
          }
        } else {
          qtyField.value = 1;
          qtPlusButton.setAttribute("disabled", "disabled");
        }

        if (currentValue === 0 && variantQty > 0) {
          qtyField.value = 1;

          if (variantQty === 1) {
            qtPlusButton.setAttribute("disabled", "disabled");
          }
        }
      }

      function setVariantQuantities(cart) {
        const options = variantStickyProduct.querySelectorAll("option");

        options.length && options.forEach((option) => {
          const currentVariantQuantity = option.getAttribute("data-product-qty");

          option.setAttribute("data-remain-qty", currentVariantQuantity);
        });

        cart && cart.items.forEach((item) => {
          const itemId = item.id;
          const itemQuantity = item.quantity;
          const variantOption = variantStickyProduct.querySelector(`option[value='${itemId}']`);

          if (variantOption) {
            const currentVariantQuantity = +variantOption.getAttribute("data-product-qty");

            variantOption.setAttribute("data-remain-qty", currentVariantQuantity - itemQuantity);
          }
        });
      }

      function setATCButtonState() {
        const currentVariant = variantStickyProduct.selectedOptions[0];

        if (!currentVariant) {
          return
        }

        const variantQty = currentVariant.hasAttribute("data-remain-qty") ? +currentVariant.dataset.remainQty : +currentVariant.dataset.productQty;

        if (variantQty > 0) {
          stickyATCButton.removeAttribute("disabled");
          stickyATCButtonText.innerHTML = theme.strings.addToCart;
        } else {
          stickyATCButton.setAttribute("disabled", "disabled");
          stickyATCButtonText.innerHTML = theme.strings.soldOut;
        }

        document.dispatchEvent(new CustomEvent("stickyATCButtonStateChanged"));
      }

      setVariantQuantities(cart);
      checkQuantity();
      checkPrice();
      setATCButtonState();

      if (qtBox) {
        qtBox.querySelectorAll("button").forEach(button => {
          button.addEventListener("click", (event) => {
            checkQuantity();
          })
        });
      }

      // Variant change
      if (variantStickyProduct) {
        variantStickyProduct.addEventListener("change", async (event) => {
          let currentSelect = event.target;
          let selectCurrentValue = currentSelect.value;
          let currentVariantPrice = currentSelect.options[currentSelect.selectedIndex].dataset.price;
          const singleProductBox = document.querySelector(".product-single");
          const pickerType = document.querySelector("#section-product-template").dataset.pickerType;
          const currentSelectedOption = currentSelect.selectedOptions[0];
          const variantOptionsSize = currentSelectedOption.dataset.optionSize;
          const swatchesIsPresent = !!document.querySelector(".dbtfy-color_swatches");

          changeStickyPanelVariantImage(selectCurrentValue);
          setMaxQuantity();
          checkQuantity();
          setATCButtonState();

          stickyATC.querySelector(".total-sticky-price").innerHTML = `<span class="money">${theme.Currency.formatMoney(currentVariantPrice, moneyFormat)}</span>`;

          checkPrice();

          let currencySelector = document.querySelector("#currency-list-header[name='dbtfy-custom-currencies']"),
            shopCurrency = theme.strings.shopCurrency;

          if (currencySelector) {
            Currency.convertAll(shopCurrency, Currency.currentCurrency, ".dbtfy-sticky-price-box .money");
          }

          for (let i = 1; i <= variantOptionsSize; i++) {
            const currentVariantOptionName = currentSelectedOption.dataset[`option-${i}`];
            const swatchesOption = singleProductBox.querySelector(`.input-color_swatches[value="${currentVariantOptionName}"]`);

            if (pickerType === "radio") {
              const fieldsetOptions = document.querySelector(`#ProductSelect-option-${i - 1}`);

              fieldsetOptions.querySelector(`.single-option-selector__radio[value="${currentVariantOptionName}"]`).click();
            } else {
              const productVariantSelect = document.querySelector(`#SingleOptionSelector-${i - 1}`);

              productVariantSelect.value = currentVariantOptionName;
              productVariantSelect.dispatchEvent(new Event("change"));
            }

            if (swatchesIsPresent && swatchesOption) {
              let swatchBox = swatchesOption.closest(".custom_swatch_elements");
              let swatchOptionLabel = swatchBox.querySelector(".single-option-radio__label");
              let labelTitle = swatchOptionLabel.dataset.label;

              swatchOptionLabel.innerHTML = `${labelTitle}: <span class="variant-label-option-value">${swatchesOption.value}</span>`;

              swatchesOption.checked = true;
            }
          }
        });
      }

      listVariantSelects.forEach((select) => select.addEventListener("change", (event) => {
        let stickyPanelHasVariant = variantStickyProduct.querySelector(`option[value="${masterSelect.value}"]`);

        if (!productTemplateMetaContainer.classList.contains("variant-unavailable") && stickyPanelHasVariant) {
          variantStickyProduct.value = masterSelect.value;
          changeStickyPanelVariantImage(variantStickyProduct.value);
          setATCButtonState();
          checkPrice();
        }
      }));

      function changeStickyPanelVariantImage(currentValue) {
        stickyImages.forEach((image) => {
          image.classList.add("hide");
        });

        if (currentValue) {
          document.querySelector(`.image-sticky_addtocart-${currentValue}`).classList.remove("hide");
        }
      }

      $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
        setVariantQuantities(cart);
        checkQuantity();
        checkPrice();
        setATCButtonState();
      });

      document.addEventListener("productInfoLoaded", () => {
        setATCButtonState();
      });
    }

    StickyAddtocart();}

  function themeStickyAddtocartDestroy() {document.body.classList.add("dbtfy-sticky_addtocart-destroy");

    destroyStickyAddtocart();

    function destroyStickyAddtocart() {
      const stickyATCs = document.querySelectorAll(".dbtfy-sticky_addtocart");

      stickyATCs.length && stickyATCs.forEach((stickyATC) => {
        stickyATC.remove();
      });
    }}
  /* end-dbtfy-sticky-addtocart */

  /* start-dbtfy-synced-variant-image */
  function themeSyncedVariantImage() {}
  /* end-dbtfy-synced-variant-image */

  /* start-dbtfy-trust-badge */
  function themeTrustBadgeDestroy() {destroyTrustBadge();

    function destroyTrustBadge() {
      const trustBadges = document.querySelectorAll(".dbtfy-trust_badge");

      trustBadges.length && trustBadges.forEach((trustBadge) => {
        trustBadge.remove();
      });
    }}
  /* end-dbtfy-trust-badge */

  /* start-dbtfy-upsell-bundles */
  function themeUpsellBundles() {function UpsellBundles() {
      var dbtfy = $(".dbtfy-upsell_bundles");

      if (!dbtfy.length) {
        return;
      }

      var $container = $("#UpsellBundles");
      var position = $container.data("position");
      var sectionId = $container.data("sectionId");
      var productId = $container.data("productId");
      var limit = $container.data("limit");
      var recommendationsSectionUrl = `/recommendations/products?&section_id=${sectionId}&product_id=${productId}&limit=${limit}`;

      // Once bundle is loaded
      function upsellBundleLoaded() {
        var $buttonBundle = $(".btn-upsell_bundles");
        var $bundleSelect = $(".select-upsell_bundles");
        var bundleTotal = $(".total-upsell_bundles");
        let bundleCompareTotal = $(".compare-total-upsell_bundles");
        let discountBox = $(".discount-upsell_bundles");
        let discountBoxText = $(".discount-upsell_bundles_text");
        let discountVariant = $(".total-wrapper-upsell_bundles").data("discount-variant");
        let moneyFormat = theme.strings.moneyFormat;

        // Move current product inside bundle
        $(".current-image-upsell_bundles").prependTo(".image-wrapper-upsell_bundles");
        $(".current-form-upsell_bundles").prependTo(".form-wrapper-upsell_bundles");

        // Position
        if (position === "button") {
          if ($(".dbtfy-trust_badge").length) {
            dbtfy.insertAfter(".dbtfy-trust_badge");
          } else {
            dbtfy.insertAfter("#AddToCartForm--product-template");
          }
        }

        function calculateDiscount(totalPrice, totalComparePrice) {
          let discount = null;

          if (totalComparePrice > totalPrice) {
            if (discountVariant === "percentage") {
              let discountValue = Math.round(((totalComparePrice - totalPrice) * 100) / totalComparePrice);

              discount = `${discountValue}%`;
            } else {
              let discountValue = totalComparePrice - totalPrice;

              discount = `<span class="money">${theme.Currency.formatMoney(discountValue, moneyFormat)}</span>`;
            }

            discountBoxText.html(theme.strings.saveFormat.replace(/\{\{ saved_amount \}\}/, discount));
            bundleTotal.addClass("text-sale");
            discountBox.show();
          } else {
            discountBox.hide();
            bundleTotal.removeClass("text-sale");
          }
        }

        // Price function
        function checkPrice() {
          let totalPrice = 0;
          let totalComparePrice = 0;

          $bundleSelect.each(function() {
            var currentCheckbox = $(this).closest(".form-item-upsell_bundles").find(".checkbox-upsell_bundles");

            if (currentCheckbox.is(":checked")) {
              totalPrice += parseInt($(this).children("option:selected").data("price"));

              let dataComparePrice = parseInt($(this).children("option:selected").data("compare-at-price"));

              if (dataComparePrice > 0) {
                totalComparePrice += dataComparePrice;
              } else {
                totalComparePrice += parseInt($(this).children("option:selected").data("price"));
              }
            }
          });

          bundleTotal.data("total", totalPrice).html(`<span class="money">${theme.Currency.formatMoney(totalPrice, moneyFormat)}</span>`);

          if (totalPrice < totalComparePrice) {
            bundleCompareTotal.data("total", totalComparePrice).html(`<span class="money">${theme.Currency.formatMoney(totalComparePrice, moneyFormat)}</span>`);
            bundleCompareTotal.show();
          } else {
            bundleCompareTotal.hide();
          }

          calculateDiscount(totalPrice, totalComparePrice);

          // Convert the product price on select change based on selected currency
          var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
            shopCurrency = theme.strings.shopCurrency;

          if (currencySelector.length && shopCurrency && Currency.currentCurrency) {
            Currency.convertAll(shopCurrency, Currency.currentCurrency);
          }
        }

        function verifyUnchecked() {
          const upsellBuyButton = document.querySelector(".btn-upsell_bundles");
          const upsellCheckbox = document.querySelectorAll(".checkbox-upsell_bundles");

          const empty = [].filter.call(upsellCheckbox, function (el) {
            return !el.checked;
          });

          if (upsellCheckbox.length === empty.length) {
            upsellBuyButton.classList.add("disabled");
            upsellBuyButton.setAttribute("disabled", "disabled");
          } else {
            upsellBuyButton.classList.remove("disabled");
            upsellBuyButton.removeAttribute("disabled", "disabled");
          }
        }

        // checkbox on click
        $(".checkbox-upsell_bundles").on("click", function() {
          var $this = $(this);
          var productId = $this.data("productId");
          var index = $this.data("index");
          var targetImage = $(`.grid-image-${productId}-${index}`);
          var targetForm = $(`#upsellBundles-${productId}-${index}`);

          if ($this.is(":checked")) {
            targetImage.addClass("selected-image-upsell_bundles");
            targetForm.addClass("active-upsell_bundles");
          } else {
            targetImage.removeClass("selected-image-upsell_bundles");
            targetForm.removeClass("active-upsell_bundles");
          }

          verifyUnchecked();
          checkPrice();
        });

        // Select on change
        $bundleSelect.on("change", function() {
          var selectValue = $(this).val();
          var currentImage = $(`#imageUpsellBundles-${selectValue}`);
          var siblingImages = currentImage.siblings();
          let selectedVariant = $(this).find("option:selected");
          let currentPriceBox = $(this).next(".dbtfy-upsell-bundle-price-wrapper").find(".dbtfy-upsell-bundle-current-price");
          let comparePriceBox = $(this).next(".dbtfy-upsell-bundle-price-wrapper").find(".dbtfy-upsell-bundle-compare-price");
          let variantCurrentPrice = selectedVariant.data("price");
          let variantComparePrice = selectedVariant.data("compare-at-price");

          // Change image
          siblingImages.hide();
          currentImage.show();

          if (variantCurrentPrice > variantComparePrice) {
            currentPriceBox.removeClass("text-sale");
            comparePriceBox.hide();
          } else {
            currentPriceBox.addClass("text-sale");
            comparePriceBox.show();
          }

          currentPriceBox.html(`<span class="money">${theme.Currency.formatMoney(variantCurrentPrice, moneyFormat)}</span>`);
          comparePriceBox.html(`<span class="money">${theme.Currency.formatMoney(variantComparePrice, moneyFormat)}</span>`);

          // Change price
          checkPrice();
        });

        $(document).ready(function() {
          checkPrice();
        });

        // Add bundle to cart
        $buttonBundle.on("click", function() {
          var $btn = $(this);
          let $form = document.querySelectorAll(".form-upsell_bundles.active-upsell_bundles");
          const cartType = theme.settings.cartType;

          theme.loadingState.init($btn);

          dbtfy.find(".errors").remove();

          ShopifyAPI.addItemFromForm(
            $form,
            () => {
              if (cartType === "page") {
                if (document.body.classList.contains("template-cart")) {
                  theme.ajaxCart.update();
                } else {
                  window.location.assign("/cart");
                }
              } else if (cartType === "drawer") {
                theme.ajaxCart.update();

                $("body").on("ajaxCart.afterCartLoad", function(evt, cart) {
                  theme.loadingState.destroy($btn);
                });
              }
            },
            (XMLHttpRequest, textStatus, form) => {
              const data = eval(`(${XMLHttpRequest.responseText})`);

              theme.loadingState.destroy($btn);

              if (data.message) {
                if (data.status === 422) {
                  $btn.after(
                    `<div class="errors qty-error">${data.description}</div>`
                  );
                }
              }
            }
          );
        });

      }

      if ($container.hasClass("specific-upsell_bundles")) {
        upsellBundleLoaded();
      } else {
        $.get(recommendationsSectionUrl).then(function(section) {
          var recommendationsMarkup = $(section).find("#UpsellBundles").html();

          if (recommendationsMarkup && recommendationsMarkup.trim() !== "") {
            $container.html(recommendationsMarkup);

            upsellBundleLoaded();
          }
        });
      }

      $(document).on("shopify:section:load", function() {
        upsellBundleLoaded();
      });
    }

    UpsellBundles();}

  function themeUpsellBundlesDestroy() {destroyUpsellBundles();

    function destroyUpsellBundles() {
      const upsellBundles = document.querySelectorAll(".dbtfy-upsell_bundles");

      upsellBundles.length && upsellBundles.forEach((upsellBundle) => {
        upsellBundle.remove();
      });
    }}
  /* end-dbtfy-upsell-bundles */

  /* start-dbtfy-upsell-popup */
  function themeUpsellPopup() {}

  function themeUpsellPopupDestroy() {}
  /* end-dbtfy-upsell-popup */

  /* start-dbtfy-wish-list */
  function themeWishList() {}

  function themeWishListDestroy() {}
  /* end-dbtfy-wish-list */

  document.addEventListener("dbtfy:loaded", function(event) {
    /* start-register */
    var sections = new theme.Sections();

    const addons = {
      "dbtfy_addtocart_animation": {
        "init": () => {
          sections.register("product-template", themeAddtocartAnimation);
        },
        "destroy": () => {}
      },
      "dbtfy_age_check": {
        "init": themeAgeCheck,
        "destroy": themeAgeCheckDestroy
      },
      "dbtfy_agree_to_terms": {
        "init": themeAgreeToTerms,
        "destroy": themeAgreeToTermsDestroy
      },
      "dbtfy_automatic_geolocation": {
        "init": themeAutomaticGeolocation,
        "destroy": () => {}
      },
      "dbtfy_back_in_stock": {
        "init": themeBackInStock,
        "destroy": themeBackInStockDestroy
      },
      "dbtfy_cart_countdown": {
        "init": themeCartCountdown,
        "destroy": themeCartCountdownDestroy
      },
      "dbtfy_cart_discount": {
        "init": themeCartDiscount,
        "destroy": themeCartDiscountDestroy
      },
      "dbtfy_cart_favicon": {
        "init": themeCartFavicon,
        "destroy": () => {}
      },
      "dbtfy_cart_goal": {
        "init": themeCartGoal,
        "destroy": themeCartGoalDestroy
      },
      "dbtfy_cart_savings": {
        "init": themeCartSavings,
        "destroy": themeCartSavingsDestroy
      },
      "dbtfy_cart_upsell": {
        "init": themeCartUpsell,
        "destroy": themeCartUpsellDestroy
      },
      "dbtfy_collection_addtocart": {
        "init": themeCollectionAddtocart,
        "destroy": themeCollectionAddtocartDestroy
      },
      "dbtfy_collection_filters": {
        "init": themeCollectionFilters,
        "destroy": themeCollectionFiltersDestroy
      },
      "dbtfy_color_swatches": {
        "init": themeColorSwatches,
        "destroy": themeColorSwatchesDestroy
      },
      "dbtfy_cookie_box": {
        "init": themeCookieBox,
        "destroy": themeCookieBoxDestroy
      },
      "dbtfy_custom_currencies": {
        "init": themeCustomCurrencies,
        "destroy": themeCustomCurrenciesDestroy
      },
      "dbtfy_delivery_time": {
        "init": () => {},
        "destroy": themeDeliveryTimeDestroy
      },
      "dbtfy_discount_saved": {
        "init": themeDiscountSaved,
        "destroy": themeDiscountSavedDestroy
      },
      "dbtfy_faq_page": {
        "init": () => {
          sections.register("faq-page", themeFaqPage);
        },
        "destroy": themeFaqPageDestroy
      },
      "dbtfy_facebook_messenger": {
        "init": () => {},
        "destroy": themeFacebookMessengerDestroy
      },
      "dbtfy_inactive_tab_message": {
        "init": themeInactiveTabMessage,
        "destroy": () => {}
      },
      "dbtfy_infinite_scroll": {
        "init": themeInfiniteScroll,
        "destroy": themeInfiniteScrollDestroy
      },
      "dbtfy_instagram_feed": {
        "init": () => {
          sections.register("instagram-feed", themeInstagramFeed);
        },
        "destroy": themeInstagramFeedDestroy
      },
      "dbtfy_inventory_quantity": {
        "init": themeInventoryQuantity,
        "destroy": themeInventoryQuantityDestroy
      },
      "dbtfy_linked_options": {
        "init": themeLinkedOptions,
        "destroy": () => {}
      },
      "dbtfy_live_view": {
        "init": () => {
          sections.register("product-template", themeLiveView);
        },
        "destroy": themeLiveViewDestroy
      },
      "dbtfy_mega_menu": {
        "init": () => {
          sections.register("header-section", themeMegaMenu);
        },
        "destroy": themeMegaMenuDestroy
      },
      "dbtfy_menu_bar": {
        "init": () => {},
        "destroy": themeMenuBarDestroy
      },
      "dbtfy_newsletter_popup": {
        "init": themeNewsletterPopup,
        "destroy": themeNewsletterPopupDestroy
      },
      "dbtfy_order_feedback": {
        "init": themeOrderFeedback,
        "destroy": themeOrderFeedbackDestroy
      },
      "dbtfy_order_tracking": {
        "init": themeOrderTracking,
        "destroy": themeOrderTrackingDestroy
      },
      "dbtfy_page_speed_booster": {
        "init": themePageSpeedBooster,
        "destroy": () => {}
      },
      "dbtfy_page_transition": {
        "init": themePageTransition,
        "destroy": themePageTransitionDestroy
      },
      "dbtfy_pricing_table": {
        "init": () => {},
        "destroy": themePricingTableDestroy
      },
      "dbtfy_product_bullet_points": {
        "init": themeProductBulletPoints,
        "destroy": themeProductBulletPointsDestroy
      },
      "dbtfy_product_image_crop": {
        "init": () => {},
        "destroy": themeProductImageCropDestroy
      },
      "dbtfy_product_tabs": {
        "init": () => {},
        "destroy": themeProductTabsDestroy
      },
      "dbtfy_quantity_breaks": {
        "init": themeQuantityBreaks,
        "destroy": themeQuantityBreaksDestroy
      },
      "dbtfy_quick_view": {
        "init": themeQuickView,
        "destroy": themeQuickViewDestroy
      },
      "dbtfy_recently_viewed": {
        "init": themeRecentlyViewed,
        "destroy": themeRecentlyViewedDestroy
      },
      "dbtfy_sales_countdown": {
        "init": themeSalesCountdown,
        "destroy": themeSalesCountdownDestroy
      },
      "dbtfy_sales_pop": {
        "init": themeSalesPop,
        "destroy": themeSalesPopDestroy
      },
      "dbtfy_shop_protect": {
        "init": themeShopProtect,
        "destroy": () => {}
      },
      "dbtfy_size_chart": {
        "init": () => {
          sections.register("product-template", themeSizeChart);
        },
        "destroy": themeSizeChartDestroy
      },
      "dbtfy_smart_search": {
        "init": themeSmartSearch,
        "destroy": themeSmartSearchDestroy
      },
      "dbtfy_social_discount": {
        "init": () => {
          sections.register("product-template", themeSocialDiscount);
        },
        "destroy": themeSocialDiscountDestroy
      },
      "dbtfy_sticky_addtocart": {
        "init": () => {
          sections.register("product-template", themeStickyAddtocart);
        },
        "destroy": themeStickyAddtocartDestroy
      },
      "dbtfy_synced_variant_image": {
        "init": themeSyncedVariantImage,
        "destroy": () => {}
      },
      "dbtfy_trust_badge": {
        "init": () => {},
        "destroy": themeTrustBadgeDestroy
      },
      "dbtfy_upsell_bundles": {
        "init": () => {
          sections.register("bundle-recommendations", themeUpsellBundles);
        },
        "destroy": themeUpsellBundlesDestroy
      },
      "dbtfy_upsell_popup": {
        "init": () => {
          sections.register("upsell-popup", themeUpsellPopup);
        },
        "destroy": themeUpsellPopupDestroy
      },
      "dbtfy_wish_list": {
        "init": themeWishList,
        "destroy": themeWishListDestroy
      }
    };

    const enabledAddons = event.detail.enabledAddons;

    for (const [addonName, addonInfo] of Object.entries(addons)) {
      const isEnabledAddon = enabledAddons.some((enabledAddon) => {
        return enabledAddon.name === addonName;
      });

      if (isEnabledAddon) {
        addonInfo.init();
      } else {
        addonInfo.destroy();
      }
    }
    /* end-register */
  });
})();
